<div class="fullcontainer">
  <div class="row">
    <div class="col">
      <h1 class='header' style='color:white'>
        Environment Settings
      </h1>
    </div>
  </div>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later or contact support.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Environment was updated successfully</div>
  }

  <app-environment-form [environment]='this.environment'></app-environment-form>

  <div class="row">
    <div class="col btn-group">
      <button class='btn btn-success' (click)='save();'>Save</button>
      <button class='btn btn-danger' routerLink='/settings'>Cancel</button>
    </div>
  </div>
</div>
